import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 10h3v7H4zM10.5 10h3v7h-3zM2 19h20v3H2zM17 10h3v7h-3zM12 1L2 6v2h20V6z"
}), 'AccountBalance');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AccountBalance.js
// module id = 1822
// module chunks = 2